import React from "react";
import PropType from "prop-types";
import { Empty, Row, Col, DatePicker, Button, message } from "antd";
import { Chart, Geom, Axis, Tooltip, Legend, Coord, Interval } from "bizcharts";
import { ScreenSize } from "utils/constants";
// import DashboardApi from '../../../tools/Api/dashboard.api';
import { RedoOutlined } from "@ant-design/icons";
import Currency from "react-currency-formatter";
import { Color } from "@antv/attr";
import moment from "moment";

class Basiccolumn extends React.Component {
  state = {
    dateRange: [
      // moment()
      //   .subtract(7, "day")
      //   .startOf("day")
      moment().subtract(3, "month"),
      moment().endOf("day"),
    ],
    data: { revenueChart: [] },
    // data: [
    //   // {
    //   //   year: "1952",
    //   //   sales: 52
    //   // },
    //   // {
    //   //   year: "1956",
    //   //   sales: 61
    //   // },
    //   // {
    //   //   year: "1957",
    //   //   sales: 145
    //   // },
    //   // {
    //   //   year: "1958",
    //   //   sales: 48
    //   // },
    //   // {
    //   //   year: "1959",
    //   //   sales: 38
    //   // },
    //   // {
    //   //   year: "1960",
    //   //   sales: 0
    //   // },
    //   // {
    //   //   year: "1962",
    //   //   sales: 38
    //   // },
    //   // {
    //   //   year: "1963",
    //   //   sales: 48
    //   // },
    //   // {
    //   //   year: "1964",
    //   //   sales: 38
    //   // },
    //   // {
    //   //   year: "1965",
    //   //   sales: 0
    //   // },
    //   // {
    //   //   year: "1966",
    //   //   sales: 38
    //   // },
    //   // {
    //   //   year: "2019",
    //   //   sales: 0
    //   // }
    // ]
  };

  componentDidMount() {
    this.mounted = true;
    console.log("sales props", this.props);
    // this.GetSales();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  // componentWillReceiveProps(props) {
  //   console.log('props', props);

  //   if (props.data) {
  //     this.setState({
  //       data: props.data
  //     });
  //   }
  // }

  // GetSales = async () => {
  //   message.loading("Loading data...");
  //   // this.setState({ loading: true });
  //   const res = await DashboardApi.getSales(
  //     this.state.dateRange[0].unix(),
  //     this.state.dateRange[1].unix()
  //   );
  //   console.log("sale", res);

  //   if (res.status === 200) {
  //     this.setState({
  //       // loading: false,
  //       // data: res.data.data
  //     });
  //   } else {
  //     // this.setState({ loading: false });
  //     ResponseError(res);
  //   }
  // };

  numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  render() {
    const data = [
      { week: "Week 1\n wawawa", total_sales: 0, demo: "123123123" },
      { week: "Week 2", total_sales: 0 },
      { week: "Week 3", total_sales: 0 },
      { week: "Week 4", total_sales: 0 },
      { week: "Week 5", total_sales: 0 },
      { week: "Week 6", total_sales: 0 },
      { week: "Week 7", total_sales: 0 },
      { week: "Week 8", total_sales: 0 },
      // { week: "Week 1", total_sales: 275 },
      // { week: "Week 2", total_sales: 115 },
      // { week: "Week 3", total_sales: 120 },
      // { week: "Week 4", total_sales: 350 },
      // { week: "Week 5", total_sales: 150 },
      // { week: "Week 6", total_sales: 210 },
      // { week: "Week 7", total_sales: 240 },
      // { week: "Week 8", total_sales: 300 },
    ];

    const cols = {
      total_sales: { alias: "Total Sales" },
      week: { alias: "Week" },
    };

    const TransactionChart = (
      <div
        style={{
          backgroundColor: "#fff",
          padding: 16,
          borderRadius: 10,
          marginBottom: 24,
        }}
      >
        <Row justify="space-between" align="center">
          <Col>
            <h1 style={{ textAlign: "start", fontWeight: 500, fontSize: 18 }}>
              Daily Transaction Volume in MYR
            </h1>
          </Col>

          {/* <Col>
            <Row gutter={16} align="middle">
              {window.innerWidth > ScreenSize.xl && <Col>Date Range :</Col>}

              <Col
                style={{
                  marginBottom: window.innerWidth < ScreenSize.md && 16
                }}
              >
                <DatePicker.RangePicker
                  disabled={this.state.loading}
                  value={this.state.dateRange}
                  onChange={e => {
                    // console.log(e);
                    if (e) {
                      this.setState(
                        {
                          dateRange: [e[0].startOf("days"), e[1].endOf("days")]
                        },
                        () => this.GetDashboard()
                      );
                    } else {
                      this.setState(
                        {
                          dateRange: [
                            moment().subtract(7, "day").startOf("day"),
                            moment().endOf("day")
                          ]
                        }
                        // () => this.getOrderList()
                      );
                    }
                  }}
                  disabledDate={e => e && e > moment().endOf("day")}
                />
              </Col>
              <Col>
                <Button
                  type="primary"
                  onClick={() => {
                    this.GetDashboard();
                    // this.setState(
                    //   {
                    //     buValue: [],
                    //     sbuValue: [],
                    //     favoriteListValue: ""
                    //   },
                    //   () => this.GetDashboard()
                    // );
                  }}
                >
                  <RedoOutlined /> Refresh
                </Button>
              </Col>
            </Row>
          </Col> */}
        </Row>
        <Chart
          padding={[24, 24, 64, 40]}
          height={300}
          autoFit
          data={this.state.data?.revenueChart}
        >
          <Interval position="day*amount" />
          {/* <Tooltip shared /> */}
          <Tooltip shared>
            {(title, items) => {
              console.log(title, items);
              // items 是个数组，即被触发tooltip的数据。
              // 获取items的颜色
              // const color = items[0].color;
              // return <div>自定义tooltip</div>;
              return (
                <div style={{ padding: 8, width: 150 }}>
                  <Row style={{ marginBottom: 8 }}>
                    <Col span={9}>Amount</Col>
                    <Col span={2}>:</Col>
                    <Col span={13}>
                      <Currency
                        quantity={items[0].data.amount}
                        currency="MYR"
                        pattern="! #,##0.00"
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col span={9}>Count</Col>
                    <Col span={2}>:</Col>
                    <Col span={13}>{items[0].data.count}</Col>
                  </Row>
                </div>
              );
            }}
          </Tooltip>
        </Chart>
      </div>
    );

    const RefundChart = (
      <div
        style={{
          backgroundColor: "#fff",
          padding: 16,
          borderRadius: 10,
        }}
      >
        <Row justify="space-between" align="center">
          <Col>
            <h1 style={{ textAlign: "start", fontWeight: 500, fontSize: 18 }}>
              Daily Refund Volume in MYR
            </h1>
          </Col>

          {/* <Col>
            <Row gutter={16} align="middle">
              {window.innerWidth > ScreenSize.xl && <Col>Date Range :</Col>}

              <Col
                style={{
                  marginBottom: window.innerWidth < ScreenSize.md && 16
                }}
              >
                <DatePicker.RangePicker
                  disabled={this.state.loading}
                  value={this.state.dateRange}
                  onChange={e => {
                    // console.log(e);
                    if (e) {
                      this.setState(
                        {
                          dateRange: [e[0].startOf("days"), e[1].endOf("days")]
                        },
                        () => this.GetDashboard()
                      );
                    } else {
                      this.setState(
                        {
                          dateRange: [
                            moment().subtract(7, "day").startOf("day"),
                            moment().endOf("day")
                          ]
                        }
                        // () => this.getOrderList()
                      );
                    }
                  }}
                  disabledDate={e => e && e > moment().endOf("day")}
                />
              </Col>
              <Col>
                <Button
                  type="primary"
                  onClick={() => {
                    this.GetDashboard();
                    // this.setState(
                    //   {
                    //     buValue: [],
                    //     sbuValue: [],
                    //     favoriteListValue: ""
                    //   },
                    //   () => this.GetDashboard()
                    // );
                  }}
                >
                  <RedoOutlined /> Refresh
                </Button>
              </Col>
            </Row>
          </Col> */}
        </Row>

        <Chart
          padding={[24, 24, 64, 40]}
          height={300}
          autoFit
          data={this.state.data?.refundChart}
        >
          <Interval position="day*amount" />
          {/* <Tooltip shared /> */}
          <Tooltip shared>
            {(title, items) => {
              console.log(title, items);
              // items 是个数组，即被触发tooltip的数据。
              // 获取items的颜色
              // const color = items[0].color;
              // return <div>自定义tooltip</div>;
              return (
                <div style={{ padding: 8, width: 150 }}>
                  <Row style={{ marginBottom: 8 }}>
                    <Col span={9}>Amount</Col>
                    <Col span={2}>:</Col>
                    <Col span={13}>
                      <Currency
                        quantity={items[0].data.amount}
                        currency="MYR"
                        pattern="! #,##0.00"
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col span={9}>Count</Col>
                    <Col span={2}>:</Col>
                    <Col span={13}>{items[0].data.count}</Col>
                  </Row>
                </div>
              );
            }}
          </Tooltip>
        </Chart>
      </div>
    );

    return (
      <div>
        {TransactionChart}
        {RefundChart}
      </div>
    );
  }
}

Basiccolumn.propType = {
  style: PropType.object,
};

export default Basiccolumn;
